import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { runAnalysis } from '../../services/analysisClient';

export const AnalysisModule: React.FC = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['analysis', 'demo'],
    queryFn: () => runAnalysis({ model_id: 'demo', parameters: { a: 1 } })
  });

  return (
    <section>
      <h2>Analysis</h2>
      {isLoading && <p>Loading...</p>}
      {error && <p role="alert">Error loading analysis</p>}
      {data && (
        <pre aria-label="analysis-result">{JSON.stringify(data, null, 2)}</pre>
      )}
    </section>
  );
};
